'use strict';

var { tns } = require("tiny-slider");
var contentCarouselA11y = require('friartux/components/contentCarouselA11y');

$(document).ready(function() {
    let $slider = $('.sts-home-slider');
    let prevText = $slider.data('prev-text') || 'Previous';
    let nextText = $slider.data('next-text') || 'Next';

    let homepageTileSlider = tns({
        container: '.sts-home-slider',
        autoplayButton: false,
        items: 3,
        slideBy: "page",
        mouseDrag: true,
        controls: true,
        controlsText: [
            '<span class="sr-only">' + prevText + '</span>',
            '<span class="sr-only">' + nextText + '</span>'
        ],
        center: false,
        gutter: 20,
        autoWidth: false,
        // Loop, not rewind: without it tiny-slider stops at `count - ceil(items)`, so at
        // the fractional 1.5 / 2.5 item layouts the last product can never be shown in
        // full. A loop also never disables Next/Previous under keyboard focus. The clones
        // it adds are kept out of the list and the tab order by contentCarouselA11y.
        loop: true,
        responsive: {
            320: {
                items: 1.5,
                slideBy: 1,
                gutter: 20,
            },
            576: {
                items: 2,
                gutter: 20,
            },
            1160: {
                items: 2.5,
                slideBy: 2,
                gutter: 20,
            },
            1480: {
                items: 3,
                slideBy: "page",
                gutter: 20,
            }
        }
    });

    window.homepageTileSlider = homepageTileSlider;

    // List semantics, focus-follows-slide and the Previous/Next status message.
    // See components/contentCarouselA11y.
    let $region = $slider.closest('.homepageProductTile-component-container');
    contentCarouselA11y.init(homepageTileSlider, {
        $region: $region,
        $heading: $region.find('.maintitle')
    });
});
